import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { BroadcastingInfo } from 'src/app/models/broadcastings-models/broadcasting-info.model';
import { EMPTY, Subscription } from 'rxjs';
import { BroadcastingsService } from 'src/app/services/broadcastings-services/broadcastings.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { tap } from 'rxjs/internal/operators/tap';
import { catchError } from 'rxjs/internal/operators/catchError';

@Component({
  selector: 'app-broadcastings-broadcasting-centers-card',
  templateUrl: './broadcastings-broadcasting-centers-card.component.html',
  styleUrls: ['./broadcastings-broadcasting-centers-card.component.scss']
})
export class BroadcastingsBroadcastingCentersCardComponent implements OnInit, OnDestroy {

  @Input() broadcasting: BroadcastingInfo;
  centers;
  selectedCenters;
  updateBroadcastingCentersSubscription: Subscription;

  constructor(private broadcastingsService: BroadcastingsService,
              private userStorageService: UserStorageService,
              private snackbarService: SnackBarService) { }

  ngOnInit() {
    this.centers = this.userStorageService.getCenterList();
  }

  public duallistboxOutputEventReceiver(selectedCenters) {
    const aux = new Array();
    for (const d of selectedCenters) {
      aux.push(d[1]._data);
    }
    if (aux) {
      this.selectedCenters = aux;
      this.updateBroadcastingCenters();
    }
  }

  public updateBroadcastingCenters() {
    this.updateBroadcastingCentersSubscription = this.broadcastingsService.updateBroadcastingCenters(this.broadcasting.BroadcastingInternalId, this.broadcasting.Active, this.broadcasting.ShowApp, this.selectedCenters).pipe(
      tap(o => this.broadcastingsService.refreshBroadcasting()),
      tap(o => this.snackbarService.open('broadcastings-page.snackbar messages.update broadcasting success', 'success')),
      catchError(error => {  this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  ngOnDestroy() {
    if (this.updateBroadcastingCentersSubscription) { this.updateBroadcastingCentersSubscription.unsubscribe(); }
  }
}
